import { render, staticRenderFns } from "./GradingRuleEdit.vue?vue&type=template&id=59aa876e"
import script from "../../controllers/grading_setting/grading-rule-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/grading_setting/grading-rule-edit.js?vue&type=script&lang=js&external"
import style0 from "./GradingRuleEdit.vue?vue&type=style&index=0&id=59aa876e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports